import { render, staticRenderFns } from "./PenaltyListModal.vue?vue&type=template&id=20bc652e&scoped=true&"
import script from "./PenaltyListModal.vue?vue&type=script&lang=js&"
export * from "./PenaltyListModal.vue?vue&type=script&lang=js&"
import style0 from "./PenaltyListModal.vue?vue&type=style&index=0&id=20bc652e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bc652e",
  null
  
)

export default component.exports